import {Box, Button, CircularProgress, IconButton} from "@mui/material";
import {useEffect, useState} from "react";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";
import ProductForm from "../components/Products/ProductForm";
import ProductInfo from "../components/Products/ProductInfo";
import TenantUserRolesGrid from "../components/Tenants/TenantUserRolesGrid";
import Window from "../components/Window/Window";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import DetailTabsSection from "../components/ui/DetailTabsSection";
import useApiRequest from "../hooks/useApiRequest";
import useConfirmDialog from "../hooks/useConfirmDialog";
import {useAuthPermissions, ACTIONS, RESOURCES} from "../hooks/useAuthPermissions";
import {snackbar} from "../utils/snackbar";

const ProductDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const id = state?.id;

  const isNewProduct = !id;

  const {data, loading, read, remove} = useApiRequest({baseUrl: `/products`, resource: "products"});

  const [isEditing, setIsEditing] = useState(isNewProduct);
  const {can} = useAuthPermissions();
  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async () => {
    const {success} = await remove(id);
    if (!success) return;

    snackbar.success("Producto eliminado correctamente.");
    navigate("/products");
  });

  useEffect(() => {
    if (!isNewProduct) {
      read(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleOpenDeleteDialog = () => {
    openDialog(id, data?.name || "");
  };

  return (
    <>
      <Window
        title={isNewProduct ? "Nuevo Producto" : "Detalles del Producto"}
        backTo="/products"
        topRightButtons={
          <>
            {!isNewProduct && (
              <Box component="span">
                {can(ACTIONS.WRITE, RESOURCES.PRODUCTS) && (
                  isEditing ? (
                    <Button variant="contained" color="primary" onClick={handleEditToggle}>
                      Cancelar
                    </Button>
                  ) : (
                    <IconButton aria-label="edit" color="primary" onClick={handleEditToggle}>
                      <FiEdit2 />
                    </IconButton>
                  )
                )}

                {can(ACTIONS.DELETE, RESOURCES.PRODUCTS) && (
                  <IconButton aria-label="delete" color="error" onClick={handleOpenDeleteDialog}>
                    <FiTrash2 />
                  </IconButton>
                )}
              </Box>
            )}
          </>
        }
      >
        {loading && !isNewProduct ? (
          <CircularProgress />
        ) : (
          <>
            <Box sx={{mb: 4}}>
              {isEditing ? (
                <ProductForm
                  isNew={isNewProduct}
                  refreshData={() => read(id)}
                  setIsEditing={setIsEditing}
                  initialProductData={data || {}}
                />
              ) : (
                <ProductInfo product={data} />
              )}
            </Box>

            {!isNewProduct && (
              <DetailTabsSection
                tabs={[{label: "Usuarios y Roles", content: <TenantUserRolesGrid productId={id} />}]}
              />
            )}
          </>
        )}
      </Window>

      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="producto"
        entityLabel={itemName}
      />
    </>
  );
};

export default ProductDetail;
